import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ProjectService {
    constructor(private http: AuthHttp) { }

    getProjectsForFacilityAndYear(facilityId, year) {
        return this.http.get('/api/projects?facilityId=' + facilityId + '&year=' + year);
    }

    getProject(projectId) {
        return this.http.get('api/projects/' + projectId);
    }

    getPastProjects(portId, mapType, projectTypeId) {
        return this.http.get('api/projects/past?portId=' + portId + '&type=' + mapType + '&projectType=' + projectTypeId);
    }

    getFutureProjects(portId, mapType, projectTypeId) {
        return this.http.get('api/projects/future?portId=' + portId + '&type=' + mapType + '&projectType=' + projectTypeId);
    }

    getCurrentProjects(portId, mapType, projectTypeId) {
        return this.http.get('api/projects/current?portId=' + portId + '&type=' + mapType + '&projectType=' + projectTypeId);
    }

    addProject(project): Observable<Response> {
        let form = new FormData();
        Object.keys(project).forEach(key => {
            form.append(key, project[key]);
        });

        return this.http.post('api/projects', form)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });;
    }

    updateProject(project): Observable<Response> {
        let form = new FormData();
        Object.keys(project).forEach(key => {
            form.append(key, project[key]);
        });

        return this.http.put('api/projects', form)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });;
    }

    uploadProjectFile(projectId, file) {
        let form = new FormData();
        form.append("ProjectId", projectId);
        form.append("File", file, file.name);

        return this.http.post('/api/projects/files', form)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    updateProjectPosition(project): Observable<Response> {
        return this.http.put('/api/projects/map', project)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    deleteProjectFile(fileId): Observable<Response> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers, body: { Id: fileId } });

        return this.http.delete('/api/projects/files', options)
            .map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json()));
    }
}




// WEBPACK FOOTER //
// ./Angular/app/_services/project.service.ts